import { useMemo } from 'react'
import { useDataChange } from 'Simple/Data.js'

function formatRelative(relative) {
  let { from_person_record: person, id, to_person_record } = relative
  let { contact_method_associations } = person
  return contact_method_associations
    .map(cma => {
      let { postal_address, contact_method_id, id: cma_id } = cma
      return {
        id,
        person,
        address: postal_address,
        contact_method_id,
        type: relative.type,
        cma_id,
      }
    })
    .filter(obj => {
      return !to_person_record.contact_method_associations
        .map(cma => cma.contact_method_id)
        .includes(obj.contact_method_id)
    })
}
export default function useDataTransform(props, data) {
  let toggleShowType = useDataChange({
    context: 'new_address',
    viewPath: props.viewPath,
    path: 'show_choose_type',
  })
  return useMemo(() => {
    if (!data) return data

    let addresses = data
      .filter(
        relative =>
          relative?.from_person_record?.contact_method_associations.length > 0
      )
      .flatMap(formatRelative)
    toggleShowType(addresses.length !== 0)
    return addresses
  }, [data])
}
